
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.51 5.977h2.055c.183 0 .275.09.275.274v24.114c0 .182-.092.274-.274.274H16.51c-.182 0-.274-.092-.274-.274V6.25c0-.183.092-.274.274-.274z","fill":"#EA983F"}}),_c('path',{attrs:{"d":"M6.028 17.007h23.018c.183 0 .274.091.274.274v2.055c0 .183-.091.274-.274.274H6.028c-.183 0-.274-.091-.274-.274v-2.055c0-.183.091-.274.274-.274z","fill":"#EA983F"}})])
          )
        }
      }
    